(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const bar = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const stickySelect = document.getElementById('sticky-atc-variant-select');

  // Find the main ATC button on the page
  const mainBtn = document.querySelector('[name="add"]') || document.querySelector('.product-form__submit');

  if (!bar || !mainBtn) return;

  // Show/hide bar based on main button visibility
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainBtn);

  // Sync variant select with main page variant picker
  const mainSelect = document.querySelector('.product-form select[name="id"]');
  if (mainSelect && stickySelect) {
    mainSelect.addEventListener('change', function() {
      stickySelect.value = this.value;
    });
    stickySelect.addEventListener('change', function() {
      mainSelect.value = this.value;
      mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Add to cart click
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      const variantId = stickySelect ? stickySelect.value : (mainSelect ? mainSelect.value : null);
      if (!variantId) return;

      stickyBtn.textContent = 'Adding...';
      stickyBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        stickyBtn.textContent = 'Added ✓';
        setTimeout(function() {
          stickyBtn.textContent = 'Add to Cart';
          stickyBtn.disabled = false;
        }, 2000);
        // Trigger cart refresh if theme supports it
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function() {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.disabled = false;
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
